<app-hero />
<app-about />
<app-menu />
<app-gallery />
<app-testimonials />
@if (showReservation()) {
  <app-reservation />
}
<app-contact />
